import React, { useEffect, useState } from "react";
import moment from "moment";
import { Pagination } from "antd";
import CustomTable from "src/components/custom-table/custom-table";
import clsx from "clsx";
import { formatNumber } from "src/utils/helper/functions";
import { TableProps } from "antd/es/table";
import CustomInput from "src/components/custom-input/custom-input.component";
import instance from "src/store/axios";
import toast from "react-hot-toast";
import Loading from "src/components/loading/loading.component";
import { currenyDecimals } from "src/utils/data/constant";

type HistoryDrawerProps = {
  setOpenHistoryDrawer: (value: boolean) => void;
  history: any;
};

let searchTimer: any = null;

const HistoryDrawer: React.FC<HistoryDrawerProps> = ({
  setOpenHistoryDrawer,
  history,
}: HistoryDrawerProps) => {
  const [searchWord, setSearchWord] = useState<any>();
  const [typedValue, setTypedValue] = useState<any>();
  const [currentPage, setCurrentPage] = useState(1);

  const columns: TableProps<any>["columns"] = [
    {
      title: "Fund name",
      dataIndex: "fundName",
      key: "fundName",
      fixed: "left",
      render: (_, record) => (
        <span>{record?.mutualFund?.NAME || record?.mutualFund?.NAME}</span>
      ),
    },
    {
      title: "Subscription status",
      dataIndex: "SubscriptionStatus",
      key: "SubscriptionStatus",
      render: (_, record) =>
        record?.subscription ? (
          <div className="flex items-center gap-1">
            <div
              className={clsx(
                "w-2 h-2 rounded-full",
                record?.subscription?.status === "Approved"
                  ? "bg-green-600"
                  : record?.subscription?.status === "Pending"
                  ? "bg-amber-500"
                  : "bg-red-600"
              )}
            />
            <span>{record?.subscription?.status}</span>
          </div>
        ) : (
          <span className="ps-8">-</span>
        ),
    },
    {
      title: "Portfolio",
      dataIndex: "portfolio",
      key: "portfolio",
      render: (_, record) => <span>{record?.portfolio?.accountCode}</span>,
    },
    {
      title: "Execution date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text: string) => (
        <span>{moment(text)?.format("MMM DD, YYYY")}</span>
      ),
    },
    {
      title: "Status date",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text: string) => (
        <span>{moment(text)?.format("MMM DD, YYYY")}</span>
      ),
    },
    {
      title: "Investment amount",
      dataIndex: "subscriptionAmount",
      key: "subscriptionAmount",
      render: (text, record) => (
        <span>
          {formatNumber(text, currenyDecimals[record?.subscriptionCurrency])}
        </span>
      ),
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      render: (_, record) => <span>{record?.subscriptionCurrency}</span>,
    },
    {
      title: "Auto invest status",
      dataIndex: "status",
      key: "status",
      render: (text, record) =>
        record?.status === "MANUAL" ? (
          <div className="w-24 px-4 py-1.5 bg-white rounded-[30px] outline outline-1 outline-offset-[-1px] outline-blue-600 inline-flex justify-center items-center gap-2.5">
            <div className="justify-start text-blue-600 text-xs font-semibold">
              {text}
            </div>
          </div>
        ) : record?.status === "SKIPPED" ? (
          <div className="w-24 px-4 py-1.5 bg-white rounded-[30px] outline outline-1 outline-offset-[-1px] text-neutral-400 inline-flex justify-center items-center gap-2.5">
            <div className="justify-start text-neutral-400 text-xs font-semibold font-['Montserrat']">
              {text}
            </div>
          </div>
        ) : record?.status === "PENDING" ? (
          <div className="w-24 px-4 py-1.5 bg-white rounded-[30px] outline outline-1 outline-offset-[-1px] text-amber-500 inline-flex justify-center items-center gap-2.5">
            <div className="justify-start text-amber-500 text-xs font-semibold font-['Montserrat']">
              {text}
            </div>
          </div>
        ) : (
          <div className="px-4 py-1.5 bg-white rounded-[30px] outline outline-1 outline-offset-[-1px] outline-green-600 inline-flex justify-center items-center gap-2.5">
            <div className="justify-start text-green-600 text-xs font-semibold font-['Montserrat']">
              {text}
            </div>
          </div>
        ),
    },
  ];

  return (
    <div className="realtive flex flex-col gap-5 p-5">
      <div className="relative text-center text-[#2a2a2a] text-base lg:text-xl font-bold">
        Auto invest
        <span
          onClick={() => setOpenHistoryDrawer(false)}
          className="cursor-pointer absolute start-2 font-normal opacity-60 text-xl lg:text-3xl"
        >
          x
        </span>
      </div>
      <div className="flex items-center gap-3 mb-3">
        <CustomInput
          prefix={
            <img
              src="/images/search.svg"
              alt="search"
              width={24}
              height={24}
              className="me-2"
            />
          }
          value={typedValue}
          onChange={(event) => {
            setCurrentPage(1);
            setTypedValue(event?.target?.value);
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
              setSearchWord(event?.target?.value);
            }, 1000);
          }}
          className="placeholder:text-[#535353] placeholde::text-lg search-notification-input"
          placeholder="Search..."
        />
      </div>
      <div className="flex flex-col gap-3">
        <CustomTable
          columns={columns}
          data={history}
          showPagination={true}
          pageSize={10}
          totalCount={history?.length}
        />
      </div>
    </div>
  );
};

export default HistoryDrawer;
